import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '10', label: 'Criada' },
			{ value: '20', label: 'Separando' },
			{ value: '30', label: 'Separada' },
			{ value: '40', label: 'Conferindo' },
			{ value: '50', label: 'Unpick' },
			{ value: '60', label: 'Conferida' },
			{ value: '65', label: 'Faturando' },
			{ value: '70', label: 'Faturada' },
			{ value: '75', label: 'Doca Expedição' },
			{ value: '80', label: 'Despachando' },
			{ value: '90', label: 'Concluída' },
			{ value: '100', label: 'Cancelada' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

